<template>
  <b-container fluid style="height: calc(100vh - 75px); overflow-y: auto">
    <b-overlay :show="isLoading" rounded="sm">
      <b-breadcrumb
        style="background-color: #f8f9fa"
        :items="itemsBreadcrumb"
      ></b-breadcrumb>
      <h2 class="mb-4">Certifications Tasks</h2>
      <b-row>
        <b-col
          cols="4"
          v-for="(tasks, tasksIndex) in $store.state.certificationFormsTasks"
          :key="tasksIndex"
        >
          <div @click="setUserTaskUrl(tasks)">
            <b-card
              bg-variant="default"
              class="mb-4 click-cursor card-wrapper"
              style="height: 20.4rem"
            >
              <b-card-text class="my-4">
                <font-awesome-icon
                  icon="graduation-cap"
                  size="8x"
                  style="color: #3ddc97"
                />
              </b-card-text>
              <b-card-text class="text-dark">
                <b>{{ tasks.task_title }}</b>
              </b-card-text>
              <b-card-text>
                <b-badge v-if="tasks.task_status == '0'" variant="info"
                  >Open</b-badge
                >
                <b-badge v-if="tasks.task_status == '1'" variant="warning"
                  >In Progress</b-badge
                >
                <b-badge v-if="tasks.task_status == '2'" variant="danger"
                  >On hold</b-badge
                >
                <b-badge v-if="tasks.task_status == '3'" variant="dark"
                  >Review</b-badge
                >
                <b-badge v-if="tasks.task_status == '4'" variant="success"
                  >Complete</b-badge
                >
              </b-card-text>
              <b-card-text>
                <b-button
                  v-if="tasks.task_status == '0'"
                  @click="setUserTaskUrl(tasks)"
                  variant="outline-info"
                  >Start</b-button
                >
                <b-button
                  v-else-if="tasks.task_status == '1'"
                  @click="setUserTaskUrl(tasks)"
                  variant="outline-warning"
                  >Continue</b-button
                >
              </b-card-text>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
export default {
  name: "employeeCertifications",
  data() {
    return {
      isLoading: false,
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          to: "dashboard",
        },
        {
          text: "Certifications",
          to: "#",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    setUserTaskUrl(tasks) {
      localStorage.setItem("taskId", tasks.id);
      if (
        tasks.form_type == 1 ||
        tasks.form_type == 8 ||
        tasks.form_type == 10
      ) {
        localStorage.removeItem("taskId");
        localStorage.removeItem("activeFormSchema");
        localStorage.removeItem("taskFormData");
        localStorage.removeItem("activeTaskStatus");

        localStorage.setItem("taskId", tasks.id);
        this.$router.push("/emplyee-user-form/" + tasks.id + "/1");
      } else if (tasks.form_type == 3) {
        localStorage.removeItem("taskId");
        localStorage.removeItem("activeFormSchema");
        localStorage.removeItem("taskFormData");
        localStorage.removeItem("activeTaskStatus");

        localStorage.setItem("taskId", tasks.id);
        this.$router.push("/emplyee-training/" + tasks.id + "/1");
      } else if (tasks.form_type == 4) {
        localStorage.setItem("taskId", tasks.id);
        this.getTaskForm(tasks.id);
      }
    },
    async getTaskForm(taskId) {
      this.formButtom = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: taskId,
          formType: 4,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if (result.data.task) {
        let form = result.data.task.schema;
        let form_data = JSON.parse(result.data.task.form_data);
        this.$store.state.userFormSubmitArray = form_data;
        localStorage.setItem("activeFormSchema", form);
        localStorage.setItem("activeTaskStatus", result.data.task.task_status);
        localStorage.setItem(
          "examAttemptsToDate",
          result.data.task.exam_attempts_count
        );

        this.$router.push("/emplyee-user-exam/" + taskId + "/1");
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>